/**
 * Detección de la plataforma de checkout (Shopify vs PrestaShop).
 *
 * Fuente única de la lógica documentada en CLAUDE.md, extraída del
 * AppConfigContext para poder testearla de forma aislada. Prioridad:
 *   1. URL param `?platform=` (máxima prioridad, en ambos sentidos):
 *      `?platform=prestashop` → PrestaShop; `?platform=shopify` → Shopify
 *      (fuerza Shopify aunque el hostname sea patitasco — la URL manda).
 *   2. Hostname contiene `patitasco` → PrestaShop
 *   3. Config backend `checkout_platform` → fallback a `shopify`
 */
export type CheckoutPlatform = 'shopify' | 'prestashop';

export interface DetectPlatformInput {
  /** `window.location.search` (ej. `"?platform=prestashop"`). */
  search: string;
  /** `window.location.hostname`. */
  hostname: string;
  /** Valor de `config.checkout_platform` (puede faltar). */
  configPlatform?: string | null;
}

export function detectPlatform({ search, hostname, configPlatform }: DetectPlatformInput): CheckoutPlatform {
  const urlPlatform = new URLSearchParams(search).get('platform');
  if (urlPlatform === 'prestashop') return 'prestashop';
  if (urlPlatform === 'shopify') return 'shopify';
  if ((hostname || '').toLowerCase().includes('patitasco')) return 'prestashop';
  return (configPlatform as CheckoutPlatform) || 'shopify';
}
